import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { DEFAULT_POOLING_INTERVAL } from 'providers/graphql/constants'
import { fromDTO } from './api/mapper'
import { GET_GOOGLE_AD_MANAGER_CONNECTION } from './api/query'
import { GoogleAdManagerConnection, UseGetConnection } from './types'

export const useGetConnection = (): UseGetConnection => {
  const [connection, setConnection] = useState<GoogleAdManagerConnection | undefined>(undefined)
  const { workspaceId } = useWorkspaceParam()

  const { loading } = useQuery(GET_GOOGLE_AD_MANAGER_CONNECTION, {
    onCompleted: ({ node: { latestGamConnectionOrder: googleAdManagerConnection } }) => {
      if (googleAdManagerConnection) {
        setConnection(fromDTO(googleAdManagerConnection))
      }
    },
    pollInterval: DEFAULT_POOLING_INTERVAL,
    variables: { workspaceId },
  })

  return { connection, loading }
}
